import React from "react";
import classes from "./tile.module.css";
import { useTile } from "../../Pregrine/ProductOptions/useTile";

const getClassName = (name, isSelected, isAvailable, hasFocus) =>
  `${name}${isSelected ? "_selected" : isAvailable ? "_available" : ""}${
    hasFocus ? "_focused" : ""
  }`;

const Tile = (props) => {
  const {
    optionEnabled,
    hasFocus,
    isSelected,
    isAvailable,
    item: { label, value_index, swatch_data },
    onClick,
    attribute_code,
  } = props;

  const talonProps = useTile({
    onClick,
    value_index,
  });

  const { handleClick } = talonProps;

  const className =
    classes[getClassName("root", isSelected, isAvailable, hasFocus)];
  let finalStyle = null;

  if (swatch_data) {
    const { thumbnail, value } = swatch_data;

    let swatchValue = "";

    if (thumbnail) {
      const imagePath = generateUrl(thumbnail, "image-swatch")(SWATCH_WIDTH);

      swatchValue = `url("${imagePath}")`;
    } else {
      swatchValue = value;
    }

    finalStyle = Object.assign(
      {},
      {
        "--venia-swatch-bg": swatchValue,
      }
    );
  }

  return (
    <button
      className={className}
      onClick={handleClick}
      title={label}
      style={{ marginBottom: "10px" }}
      type="button"
      disabled={!optionEnabled || !isAvailable}
    >
      {attribute_code === "appliances_color" && (
        <button
          className={classes.swatch}
          style={finalStyle}
          title={label}
          type="button"
        />
      )}

      <p>{label}</p>
    </button>
  );
};

export default Tile;

Tile.defaultProps = {
  hasFocus: false,
  isSelected: false,
};
